import { useLocation } from 'react-router-dom';
import BridgeMark from './BridgeMark';

/** Maps a route path fragment to its Hebrew page title + optional subtitle. */
type PageTitle = { match: string; title: string; subtitle?: string; bare?: boolean };

const TITLES: PageTitle[] = [
  // The patient home draws its own scene and greeting, so no header there.
  { match: 'patient/home',     title: '', bare: true },
  { match: 'patient/progress', title: 'ההתקדמות שלי' },
  { match: 'patient/streak',   title: 'רצף יומי' },
  { match: 'patient/games',    title: 'מרחב תרגול' },
  { match: 'patient/store',    title: 'חנות התגמולים' },
  { match: 'patient/profile',  title: 'הפרופיל שלי' },
  { match: 'therapist/dashboard',   title: 'המטופלים שלי', subtitle: 'מה עלה מהבית מאז הפגישה' },
  { match: 'therapist/summaries',   title: 'סיכומי פגישות' },
  { match: 'therapist/community',   title: 'קהילת המטפלים' },
  { match: 'therapist/profile',     title: 'האזור האישי שלי' },
  { match: 'therapist/billing',     title: 'מנוי ותשלומים' },
  { match: 'therapist/clinic-admin', title: 'ניהול קליניקה' },
];

function resolveTitle(pathname: string): PageTitle {
  const found = TITLES.find((t) => pathname.includes(t.match));
  return found ?? { match: '', title: 'ReMind' };
}

export default function BrandHeader() {
  const { pathname } = useLocation();
  const { title, subtitle, bare } = resolveTitle(pathname);
  // On desktop the therapist side menu already shows the logo.
  const inTherapistArea = pathname.startsWith('/therapist/');
  // The patient home is a full-bleed scene with its own greeting.
  if (bare) return null;

  return (
    <header className="shrink-0 dir-rtl bg-background">
      <div
        className={`flex items-center gap-3 px-5 ${bare ? 'h-14' : 'pt-4 pb-3'} ${
          inTherapistArea ? 'md:px-6 md:pt-6 max-w-6xl mx-auto w-full' : ''
        }`}
      >
        <div className={`flex items-center gap-2 shrink-0 ${inTherapistArea ? 'md:hidden' : ''}`}>
          <BridgeMark size={30} />
          {bare && <span className="text-primary font-extrabold text-lg tracking-tight">ReMind</span>}
        </div>
        {!bare && (
          <div className="min-w-0">
            <h1 className="text-foreground text-xl md:text-2xl font-extrabold tracking-tight truncate">{title}</h1>
            {subtitle && <p className="text-muted-foreground text-xs md:text-sm font-medium">{subtitle}</p>}
          </div>
        )}
      </div>
    </header>
  );
}
